export const batchKeys = {
    Start: 'Start',
    End: 'End',
    RecordEdit: 'RecordEdit',
    RecordSave: 'RecordSave',
    FieldUpdate: 'FieldUpdate',
    Fetch: 'Fetch',
    Subforms: 'Subforms',
    Subform: 'Subform',
    Columns: 'Columns',
    Actions: 'Actions',
    RecordDelete: 'RecordDelete',
    RecordUndo: 'RecordUndo',
    WarningApprove: 'WarningApprove',
    HtmlUnlock: 'HtmlUnlock',
    Olaps: 'Olaps',
    RecordColors: 'RecordColors',
    SetRecordColor: 'SetRecordColor',
    RemoveAllColors: 'RemoveAllColors',
    Action: 'Action',
    RecordZoom: 'RecordZoom',
    FieldUndo: 'FieldUndo',
    ActionEnd: 'ActionEnd',
    HtmlFetch: 'HtmlFetch',
    HtmlSignature: 'HtmlSignature',
    HtmlSave: 'HtmlSave',
    FieldSelect: 'FieldSelect',
    Help: 'Help',
    SystemConstants: 'SystemConstants',
    Statuses: 'Statuses'
};

export const ABORT = 'Aborted';

export enum ServerMethods {
    ActionRq = 'ActionRq',
    ActionEndRq = 'ActionEndRq',
    ActionsDesignRq = 'ActionsDesignRq',
    ActionsRq = 'ActionsRq',
    AlertCheckExprRq = 'AlertCheckExprRq',
    AlertChooseRq = 'AlertChooseRq',
    AlertDeleteRq = 'AlertDeleteRq',
    AlertListRq = 'AlertListRq',
    AlertOrderRq = 'AlertOrderRq',
    AlertSaveRq = 'AlertSaveRq',
    BatchRq = 'BatchRq',
    CheckModuleRq = 'CheckModuleRq',
    ColumnsRq = 'ColumnsRq',
    CountFetchRq = 'CountFetchRq',
    DataRq = 'DataRq',
    DataStoreGetRq = 'DataStoreGetRq',
    DataStoreSetRq = 'DataStoreSetRq',
    DateFormatsRq = 'DateFormatsRq',
    EndRq = 'EndRq',
    FetchRq = 'FetchRq',
    FieldSelectRq = 'FieldSelectRq',
    FieldUpdateRq = 'FieldUpdateRq',
    HelpRq = 'HelpRq',
    HtmlFetchRq = 'HtmlFetchRq',
    HtmlSaveRq = 'HtmlSaveRq',
    HtmlSignatureRq = 'HtmlSignatureRq',
    HtmlUnlockRq = 'HtmlUnlockRq',
    NumericFormatsRq = 'NumericFormatsRq',
    PackageChangeRq = 'PackageChangeRq',
    PackageSetRq = 'PackageSetRq',
    RecordDeleteRq = 'RecordDeleteRq',
    RecordEditRq = 'RecordEditRq',
    RecordSaveRq = 'RecordSaveRq',
    RecordUndoRq = 'RecordUndoRq',
    RecordZoomRq = 'RecordZoomRq',
    ReportCancelRq = 'ReportCancelRq',
    ReportColumnsRq = 'ReportColumnsRq',
    ReportDataRq = 'ReportDataRq',
    ReportDelRq = 'ReportDelRq',
    ReportListRq = 'ReportListRq',
    ReportSaveRq = 'ReportSaveRq',
    RestoreDefaultDesignRq = 'RestoreDefaultDesignRq',
    RowViewColumnsDesignRq = 'RowViewColumnsDesignRq',
    SaveActionsDesignRq = 'SaveActionsDesignRq',
    SaveRowViewColumnsDesignRq = 'SaveRowViewColumnsDesignRq',
    SaveSubformsDesignRq = 'SaveSubformsDesignRq',
    SaveTableViewColumnsDesignRq = 'SaveTableViewColumnsDesignRq',
    StartRq = 'StartRq',
    StatusesRq = 'StatusesRq',
    SubformsDesignRq = 'SubformsDesignRq',
    SubformRq = 'SubformRq',
    SubformsRq = 'SubformsRq',
    SystemPackagesRq = 'SystemPackagesRq',
    SystemConstantsRq = 'SystemConstantsRq',
    TableViewColumnsDesignRq = 'TableViewColumnsDesignRq',
    TreeNodeChildrenRq = 'TreeNodeChildrenRq',
    WarningApproveRq = 'WarningApproveRq',
    GetMessageColumnsRq = 'GetMessageColumnsRq',
    UploadImageRq = 'UploadImageRq',
    GetCoverLettersRq = 'GetCoverLettersRq'
}
